import React, { useEffect } from 'react';

import ActivePosTable from './active_pos_table.component';
import ActivePosTableMob from './active_pos_table_mob.component';
import ReturnsToggler from '../../tabs/tracking/returns_toggler/returns_toggler.component';
import './active_pos.component.css';

const ActivePos = (props) => {
  //map state to props
  const { state, setState } = props;
  const { portfolioId, returnsType, isMob } = state;
  const { data, mode, error, isLoaderVisible } = state[portfolioId];

  useEffect(() => {
    //responsive
    let timeoutId = null;
    const onResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (window.innerWidth < 440) {
          setState('isMob', true);
        } else {
          setState('isMob', false);
        }
      }, 50);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <>
      <div
        className={`d-flex justify-content-between position-relative pos-togglers ${
          isMob ? 'mob' : ''
        }`}
      >
        <div className={`pos-mode cont`}>
          <button
            type="button"
            className={`item  ${mode === 'by_portfolio' ? 'active' : ''}`}
            onClick={() => setState('mode', 'by_portfolio')}
          >
            By Portfolio
          </button>
          <button
            type="button"
            className={`item  ${mode === 'by_instrument' ? 'active' : ''}`}
            onClick={() => setState('mode', 'by_instrument')}
          >
            By Instrument
          </button>
        </div>
        <ReturnsToggler
          returnsType={returnsType}
          setReturnsType={(t) => setState('returnsType', t)}
        />
      </div>
      <div
        className={`scrollable position-relative pos-cont ${
          isMob ? 'mob' : ''
        }`}
      >
        {!isMob ? (
          <ActivePosTable
            summary={data.active[mode]}
            total={data.total}
            returnsType={returnsType}
            mode={mode}
          />
        ) : (
          <ActivePosTableMob
            summary={data.active[mode]}
            total={data.total}
            returnsType={returnsType}
            mode={mode}
          />
        )}
      </div>
      <p className="content-info-text mt-2 mb-1">
        * This is a ledger of all investments currently held in your portfolios
      </p>
    </>
  );
};

export default ActivePos;
